import multiguard from 'vue-router-multiguard';
import { checkAuth } from '@/router/_auth';
import { checkBankType } from '@/router/individual/_type';

export default {
	path: '/home/individual',
	name: 'individual',
	meta: {
		title: 'Bireysel İnternet Şube',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "individual" */ '@/views/individual/home/Home.vue')
}